import React from "react"
import { Tooltip, Typography } from "@material-ui/core"
import useStyles from "@/pages/Admin/Reports/UtmsReport/UtmsReportTable/UtmsReportTableUTMValue/styles"

type UtmsReportTableUTMValueProps = {
	utmValue: string
}

const UtmsReportTableUTMValue: React.FC<UtmsReportTableUTMValueProps> = (props) => {
	const { utmValue } = props

	const classes = useStyles()

	return (
		<Tooltip title={utmValue}>
			<Typography
				variant="body1"
				className={classes.valueText}
			>
				{utmValue}
			</Typography>
		</Tooltip>
	)
}
export default UtmsReportTableUTMValue
